const cards = [
  {
    title: '悬疑烧脑佳作合集',
    desc: '高智商反转剧情，每部都让你意想不到',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20alley%20with%20single%20warm%20streetlamp%20casting%20long%20shadows%2C%20foggy%20atmosphere%2C%20cinematic%20noir%20lighting%20with%20deep%20blacks%20and%20amber%20highlights%2C%20suspenseful%20mood%2C%20geometric%20shadow%20patterns%20on%20wet%20cobblestone%2C%20elegant%20composition&width=800&height=500&seq=card-reco-01&orientation=landscape',
  },
  {
    title: '暑期动画电影大赏',
    desc: '全家欢乐观影首选，亲子时光好伴侣',
    tag: '动画',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20light%20bursts%20in%20dark%20space%2C%20magical%20floating%20particles%20with%20warm%20golden%20and%20soft%20pastel%20glows%2C%20dreamy%20fantasy%20atmosphere%2C%20whimsical%20bokeh%20effects%2C%20deep%20navy%20background%20with%20bright%20playful%20accents%2C%20enchanting%20cinematic%20mood&width=800&height=500&seq=card-reco-02&orientation=landscape',
  },
  {
    title: '高分科幻电影精选',
    desc: '震撼视效与深度思考的完美结合',
    tag: '科幻',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20geometric%20landscape%20with%20glowing%20neon%20amber%20lines%20against%20deep%20dark%20background%2C%20digital%20particle%20effects%2C%20sci-fi%20atmosphere%20with%20warm%20golden%20and%20crimson%20light%20trails%2C%20minimalist%20futuristic%20architecture%2C%20cinematic%20depth%20and%20contrast&width=800&height=500&seq=card-reco-03&orientation=landscape',
  },
  {
    title: '经典港片修复系列',
    desc: '高清修复，重温黄金时代的港片经典',
    tag: '经典',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20street%20scene%20at%20night%20with%20warm%20neon%20sign%20reflections%2C%20rain-slicked%20pavement%2C%20vintage%20cinema%20poster%20aesthetic%2C%20deep%20amber%20and%20red%20color%20palette%2C%20atmospheric%20urban%20mood%2C%20classic%20film%20noir%20lighting%20with%20dramatic%20contrast&width=800&height=500&seq=card-reco-04&orientation=landscape',
  },
  {
    title: '豆瓣高分纪录片',
    desc: '开拓视野，探索世界的真实与精彩',
    tag: '纪录',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20world%20map%20texture%20with%20warm%20golden%20light%20highlighting%20continents%2C%20dark%20atmospheric%20background%2C%20elegant%20minimalist%20geographic%20composition%2C%20soft%20dramatic%20shadows%2C%20exploration%20and%20discovery%20mood%2C%20cinematic%20documentary%20aesthetic&width=800&height=500&seq=card-reco-05&orientation=landscape',
  },
  {
    title: '日韩热剧追更日历',
    desc: '同步更新，追剧不等待，完结一次看爽',
    tag: '日韩',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Japanese%20and%20Korean%20aesthetic%20composition%20with%20warm%20paper%20lantern%20glow%2C%20delicate%20cherry%20blossom%20silhouettes%20against%20dark%20background%2C%20soft%20amber%20and%20crimson%20lighting%2C%20calm%20contemplative%20mood%2C%20refined%20Asian%20cinema%20atmosphere%2C%20subtle%20texture%20details&width=800&height=500&seq=card-reco-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-3">
            编辑力荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            从海量片库中为你精选高分佳作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, idx) => (
            <a
              key={idx}
              href="#hero"
              className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={`天堂影院 - ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/20 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-medium bg-accent-500/90 text-background-50 rounded whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}